import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../../../components/Wrapper/GlobalWrapper";
import { Box, Button, Paper } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useSelector } from "react-redux";
import { getTrainerLists } from "../../../../../redux/features/CRDslice";
import { useDispatch } from "react-redux";
import GlobalDatagrid from "../../../../../components/mui/DataGrid/GlobalDatagrid";
import { TrainerListingTableHead } from "../../../../../components/datagrid/CRD/NewAdmissionRegister/TrainerListingTableHead";

const AssignTrainer = () => {
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { loading, trainerLists } = useSelector((store) => store.crd);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const subjectEnrollId = searchParams.get("subjectEnrollId");
  const subject = searchParams.get("subject");
  const { subjectEnrollmentId, subjectName, returnTo: rawReturnTo } = location.state || {};
  // opened from the retention workspace (stage 4): go back there after the assign so it records the demo attempt
  const returnTo = typeof rawReturnTo === 'string' && rawReturnTo.startsWith('/student-journey/') ? rawReturnTo : null;
  const onAssigned = returnTo
    ? () => navigate(returnTo, { replace: true, state: { assignedSubjectEnrollmentId: subjectEnrollmentId } })
    : undefined;
  const dispatchParams = {
    paginationData,
  };
  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getTrainerLists(dispatchParams));
    }
  }, [gridSize, pageNum, search]);

  return (
    <GlobalWrapper
      title={subjectName ? `Assign Tutor · ${subjectName}` : "Assign Tutor"}
      actions={
        <>
          <Button onClick={() => navigate(-1)} variant="outlined">
            <Icon icon="ep:back" width="25" height="25" />
            <Box ml={1}>Go Back</Box>
          </Button>
        </>
      }
    >
      <Box>
        <Paper elevation={3}>
          <GlobalDatagrid
            tableHead={TrainerListingTableHead({
              subjectEnrollId,
              subjectEnrollmentId,
              subject,
              onAssigned,
            })}
            rows={trainerLists?.data}
            meta={trainerLists?.meta?.totalRecords}
            rowUniqueId="sl_no"
            loading={loading}
            rowClick={false}
          />
        </Paper>
      </Box>
    </GlobalWrapper>
  );
};

export default AssignTrainer;
